import React from "react";
import { useState, useEffect } from "react";
import PersonalityRadarChart from "../../../../../../Component/PersonalityRadarChart";
import RangeList2 from "../Components/RangeList2";
import PageSpinner from "../../../../../../Component/PageSpinner";

const Motivation = ({ motivation }) => {
    const [communicate, setCommunicate] = useState(null);
    const [dataRange, setDataRange] = useState(null);
    useEffect(() => {
        if (motivation) {
            let values = [];
            let labels = [];
            let tempDataRange = [];

            motivation.data.map((item) => {
                values.push(item.result)
                labels.push(item.name)
                tempDataRange.push({ parameter: item.name, minLabel: "A reserved individual who does not naturally want to speak in public or in front of new people", maxLabel: "An individual who likes to be the centre of attention, speak in public and who spontaneously meets others", maxRange: "10", minRange: "0", value: item.result })
            })
            setCommunicate({
                labels: labels,
                datasets: [
                    {
                        data: values,
                        backgroundColor: '#9061F97A',
                        borderColor: '#9061F9',
                        borderWidth: 2,
                        hidden: '',
                    },
                ],
            })
            setDataRange(tempDataRange)
        }
    }, [motivation])
    return (
        <div className='flex flex-col items-center'>
            <div className='flex w-full items-center mb-7 mdb:mb-5 gap-10 px-2 mdb:px-4 justify-center flex-col mdb:flex-row'>
                <div className="w-full mdb:w-[40%] flex justify-center">
                    <div className="max-w-[520px]">
                        {communicate ? <PersonalityRadarChart data={communicate} /> : <PageSpinner />}
                    </div>
                </div>
                <div className="w-full mdb:w-[60%]">
                    <p className='font-semibold mb-2'>Motiviation</p>
                    <p className="text-gray-500">Motivation involves the attitudes, actions, and strategies individuals use to stay motivated and driven in their work. Motivation is a critical aspect of professional success and can have a significant impact on job performance, productivity, and career advancement. </p>
                </div>
            </div>
            {communicate ? <>
                {dataRange.map((item, index) => (
                    <RangeList2 data={item} color="purple" />
                ))}
            </> : <PageSpinner />}

        </div>
    )
}

export default Motivation;